import { render, staticRenderFns } from "./upgradeRulesDialog.vue?vue&type=template&id=cdecee12&scoped=true"
import script from "./upgradeRulesDialog.vue?vue&type=script&lang=js"
export * from "./upgradeRulesDialog.vue?vue&type=script&lang=js"
import style0 from "./upgradeRulesDialog.vue?vue&type=style&index=0&id=cdecee12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdecee12",
  null
  
)

export default component.exports